import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import styled from 'styled-components';
import Slider from 'react-slick';
import StyledText from '../../app/components/styledComponents/StyledText';
import StyledButton from '../../app/components/styledComponents/StyledButton';
import { useMemo, useState } from 'react';
import StyledCheckbox from '../../app/components/checkbox/StyledCheckbox';
import { Link, Route, Routes, useParams } from 'react-router-dom';
import logoIcon  from '../../assets/Images/logoIcon.jpg'

// BLOG ONE
import Blog1Image1 from './images/blog-one/image-1.webp';
import Blog1Image2 from './images/blog-one/image-2.webp';
import Blog1Image3 from './images/blog-one/image-3.webp';
import Blog1Image4 from './images/blog-one/image-4.webp';
import Blog1Image5 from './images/blog-one/image-5.webp';
import Blog1Image6 from './images/blog-one/image-6.webp';

// BLOG TWO
import Blog2Image1 from './images/blog-two/image-1.webp';

// BLOG THREE
import Blog3Image1 from './images/blog-three/image-1.webp';

// BLOG THREE
import TempImage1 from './images/temp/image-1.webp';
import TempImage2 from './images/temp/image-2.webp';
import TempImage3 from './images/temp/image-3.webp';
import TempImage4 from './images/temp/image-4.webp';
import TempImage5 from './images/temp/image-5.webp';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';

const SwiperContainer = styled.div`
  .swiper-button-prev {
    display: none;
  }

  .swiper-button-next {
    display: none;
  }

  .templateSlider .slick-slide {
    margin-right: 0px !important;
    margin-bottom: 0px;
  }
`;

const StyledBanner = styled.div`
  background-color: #cb1d8d;
`;

const StyledCard = styled.div`
  background-color: #fff;
  border-radius: 12px;
  cursor: pointer;
  
  img {
    border-radius: 12px 12px 0 0;
    height: 150px;
    width: 100%;
    object-fit; cover;
  }
`;

const data = [
  {
    author: 'BoostFloral',
    title: 'Tips for improving your Floral Website design',
    date: 'May 27th, 2024',
    description:
      'Revamp your floral website with clean design, consistent colors, simplified navigation, local imagery, Instagram integration, and compelling call-to-actions.',
    imageUrl: Blog1Image1,
    tags: ['Floral Business'],
    content: (
      <>
        <StyledText
          color="bodyMedium"
          $fontSize="18px"
          $fontWeight="400"
          className="mb-4"
          colorHex="#1B131F"
        >
          Your Floral website is an important source of business revenue, and it
          should be treated with as much attention as your physical store. You
          wouldn’t have sloppy displays, or unorganized shelves in your physical
          store, and your online store shouldn’t be any different.
          <br />
          <br />
          If your website has a bland, outdated, or simplistic design, it may be
          giving visitors a negative impression of your products or services,
          and they may not feel comfortable purchasing from your site. It’s
          important that visitors are impressed with what they see, and that the
          website provides them with a sense of trust and comfort, that they can
          safely purchase from the site, and that if they do, they will be happy
          with the outcome.
        </StyledText>

        <StyledText
          color="headingColor"
          $fontSize="25px"
          $fontWeight="700"
          className="mb-4"
          colorHex="#1B131F"
        >
          With this in mind, lets look at a few things you can do to impress
          your website visitors and convert more of them to buyers
        </StyledText>

        <StyledText
          color="bodyMedium"
          $fontSize="18px"
          $fontWeight="400"
          className="mb-2"
          colorHex="#1B131F"
        >
          The first thing to know, is that you don’t have to spend a lot of
          money to have a professional looking website. Choose a layout that is
          clean and uncluttered, with plenty of white space to highlight your
          products and avoid overwhelming visitors.
        </StyledText>
        <div className="w-100 my-4 text-center">
          <img src={Blog1Image2} alt="Featured floral products from Plantscapes Florist & Gifts" />
        </div>

        <StyledText
          color="bodyMedium"
          $fontSize="18px"
          $fontWeight="400"
          className="mb-2"
          colorHex="#1B131F"
        >
          In this example, Notice the use of high-quality product images, good
          spacing, and clearly defined sections that visitors may be interested
          in. Another great aspect is the use of different images for
          variations. When reviewing site traffic heatmaps, the variation
          buttons are almost always the most clicked item on a page, because
          visitors want to see the different options.
        </StyledText>
        <div className="w-100 my-4 text-center">
          <img src={Blog1Image3} alt="Violet Cares Floral Product Details from Plantscapes Florist & Gifts" />
        </div>

        <StyledText
          color="bodyMedium"
          $fontSize="18px"
          $fontWeight="400"
          className="mb-2"
          colorHex="#1B131F"
        >
          Another important aspect is applying consistent use of typography and
          colors throughout your site. This is essential for creating a cohesive
          and user-friendly website that enhances the user experience.
          <br />
          <br />
          Having a design system to codify the options is a great practice.
          <br />
          <br />
          These systems help ensure consistency with your brand, and the website
          builder can help apply the system correctly to your website.
        </StyledText>
        <div className="w-100 my-4 text-center">
          <img src={Blog1Image4} alt="" />
        </div>

        <StyledText
          color="bodyMedium"
          $fontSize="18px"
          $fontWeight="400"
          className="mb-4"
          colorHex="#1B131F"
        >
          Next. Simplify navigation so you can guide visitors to what they are
          most likely interested in. Having unnecessary navigation options
          detracts from the user experience. For example, having navigation
          options for all seasons and/or holidays all year round. Visitors are
          probably not looking for Fall arrangements during Spring, hide these
          irrelevant menus. If a visitor doesn’t find something that interests
          them within the first 2-3 clicks, they will most likely leave the
          site.
        </StyledText>

        <StyledText
          color="headingColor"
          $fontSize="25px"
          $fontWeight="700"
          className="mb-4"
          colorHex="#1B131F"
        >
          After improving the layout and design of your site, it’s also helpful
          to emphasize your local connection with site visitors.
        </StyledText>

        <StyledText
          color="bodyMedium"
          $fontSize="18px"
          $fontWeight="400"
          className="mb-2"
          colorHex="#1B131F"
        >
          Imagery can be your best friend. Include pictures of your storefront,
          your team, your events, and happy customers throughout your site, and
          not just on a Gallery page.
          <br />
          <br />
          This will remind visitors that you’re a real company, with real
          people, and it will help visitors get to know and trust you.
        </StyledText>
        <div className="w-100 my-4 text-center">
          <img src={Blog1Image5} alt="" />
        </div>

        <StyledText
          color="bodyMedium"
          $fontSize="18px"
          $fontWeight="400"
          className="mb-2"
          colorHex="#1B131F"
        >
          In general, most people prefer to Shop Locally, and 57% indicate that
          they would even pay more, but there is also a perception that big
          businesses are more professional and reliable, or may offer better
          service than small local businesses.
          <br />
          <br />
          This is important to keep in mind when building and updating your
          website. Not only do you need to get people to your site, but those
          visitors need to feel confident in purchasing from your site, compared
          to other sites they may Shop Around at. (window shopping is very easy
          online, and having a Better-looking website adds credibility).
          <br />
          <br />
          Another great approach is adding your Instagram feed to your website.
          Adding this integration provides dynamic content to your website which
          can boost engagement, and increase both social media and website
          traffic.
        </StyledText>
        <div className="w-100 my-4 text-center">
          <img src={Blog1Image6} alt="" />
        </div>

        <StyledText
          color="bodyMedium"
          $fontSize="18px"
          $fontWeight="400"
          className="mb-4"
          colorHex="#1B131F"
        >
          Position the feed where it’s highly visible but doesn’t overpower the
          main content, such as in the footer or a dedicated section on the
          homepage. Displaying photos of customers with your products or reposts
          of their content can provide authentic social proof and inspire
          confidence with potential buyers.
        </StyledText>

        <StyledText
          color="headingColor"
          $fontSize="25px"
          $fontWeight="700"
          className="mb-4"
          colorHex="#1B131F"
        >
          The last item I’ll touch on is the use of call to actions.
        </StyledText>

        <StyledText
          color="bodyMedium"
          $fontSize="18px"
          $fontWeight="400"
          className="mb-4"
          colorHex="#1B131F"
        >
          Remember to use Compelling Language in your Call to Actions: Try using
          clear and action-oriented language that encourages urgency (e.g.,
          "Shop Now," "Order Today").
          <br />
          <br />
          The placement is also important. Product pages should have prominent
          "Add to Cart," "Buy Now," and "Send as Gift" buttons clearly
          displayed.
          <br />
          <br />
          Special Offers are another eye-catching call to action that you may
          want visitors to choose. Highlight special offers, discounts, and
          promotions with eye-catching banners and buttons to that will attract
          attention.
        </StyledText>

        <StyledText
          color="headingColor"
          $fontSize="25px"
          $fontWeight="700"
          className="mb-2"
          colorHex="#1B131F"
        >
          Summary
        </StyledText>

        <StyledText
          color="bodyMedium"
          $fontSize="18px"
          $fontWeight="400"
          className="mb-2"
          colorHex="#1B131F"
        >
          There are many other considerations such as adding reviews to your
          website, streamlining the checkout process, and effective SEO that
          contribute to a more professional website, but if you follow these
          tips above, you’ll find that site visitors will be more engaged with
          your site.
        </StyledText>
      </>
    ),
  },
  {
    author: 'BoostFloral',
    title: 'Make Your Flower Shop Website Stand Out!',
    date: 'May 22th, 2024',
    description: 'Make Your Flower Shop Website Stand Out!',
    imageUrl: Blog2Image1,
    tags: ['Flower Shop'],
    content: (
      <>
        <StyledText
          color="bodyMedium"
          $fontSize="18px"
          $fontWeight="400"
          className="mb-4"
          colorHex="#1B131F"
        >
          Are you looking to set your flower shop website apart from large
          order-gathering sites like 1-800-Flowers? As a local business, you
          have unique strengths that can help you provide a more personalized,
          high-quality experience for your customers. Here are some friendly,
          non-technical strategies to help you stand out:
        </StyledText>

        <StyledText
          color="headingColor"
          $fontSize="25px"
          $fontWeight="700"
          className="mb-4"
          colorHex="#1B131F"
        >
          1. Emphasize Local Expertise and Community Ties
        </StyledText>

        <StyledText
          color="bodyMedium"
          $fontSize="18px"
          $fontWeight="400"
          className="mb-2"
          colorHex="#1B131F"
        >
          <strong>Local Florist Advantage:</strong> Highlight your local
          expertise and deep understanding of your community’s preferences and
          traditions. Let your customers know that you’re a part of their
          community
          <br />
          <br />
          <strong>Community Engagement:</strong> Showcase your involvement in
          local events, sponsorships, and partnerships with other local
          businesses. This builds trust and fosters a sense of community.
          <br />
          <br />
          <strong>Personal Touch:</strong> Offer personalized services such as
          custom floral arrangements, bring-your-own-vase options, and local
          delivery by your own team.
        </StyledText>

        <StyledText
          color="headingColor"
          $fontSize="25px"
          $fontWeight="700"
          className="mb-4 mt-4"
          colorHex="#1B131F"
        >
          2. Superior Quality and Unique Arrangements
        </StyledText>

        <StyledText
          color="bodyMedium"
          $fontSize="18px"
          $fontWeight="400"
          className="mb-2"
          colorHex="#1B131F"
        >
          <strong>Local Quality Assurance:</strong> Emphasize the freshness and
          quality of your flowers. Ensure every arrangement is hand-crafted and
          meets high standards.
          <br />
          <br />
          <strong>Unique Designs:</strong> Create unique, custom designs that
          can’t be found on larger sites. Highlight your creativity and the
          artistry of your arrangements.
          <br />
          <br />
          <strong>Special Collections:</strong> Offer exclusive collections for
          local events, holidays, or seasons that reflect local tastes and
          traditions.
        </StyledText>

        <StyledText
          color="headingColor"
          $fontSize="25px"
          $fontWeight="700"
          className="mb-4 mt-4"
          colorHex="#1B131F"
        >
          3. Enhanced Online Experience
        </StyledText>

        <StyledText
          color="bodyMedium"
          $fontSize="18px"
          $fontWeight="400"
          className="mb-2"
          colorHex="#1B131F"
        >
          <strong>User-Friendly Website:</strong> Ensure your website is easy to
          navigate, visually appealing, and mobile-friendly.
          <br />
          <br />
          <strong>High-Quality Content:</strong> Use high-quality images and
          detailed product descriptions to showcase your flowers. Include care
          tips and floral arrangement guides.
          <br />
          <br />
          <strong>Customer Reviews:</strong> Display customer testimonials and
          reviews prominently to build trust and showcase your reputation for
          quality and service.
        </StyledText>

        <StyledText
          color="headingColor"
          $fontSize="25px"
          $fontWeight="700"
          className="mb-4 mt-4"
          colorHex="#1B131F"
        >
          4. Local SEO and Marketing
        </StyledText>

        <StyledText
          color="bodyMedium"
          $fontSize="18px"
          $fontWeight="400"
          className="mb-2"
          colorHex="#1B131F"
        >
          <strong>Google My Business:</strong> Optimize your Google My Business
          listing with accurate information, high-quality images, and positive
          reviews.
          <br />
          <br />
          <strong>Local SEO:</strong> Focus on local SEO strategies to ensure
          your website ranks well for local search queries (e.g., “flower
          delivery in [your city]”).
          <br />
          <br />
          <strong>Social Media Presence:</strong> Actively engage with your
          local audience on social media platforms by sharing behind-the-scenes
          content, floral tips, and customer stories.
        </StyledText>

        <StyledText
          color="headingColor"
          $fontSize="25px"
          $fontWeight="700"
          className="mb-4 mt-4"
          colorHex="#1B131F"
        >
          5. Exclusive Offers and Loyalty Programs
        </StyledText>

        <StyledText
          color="bodyMedium"
          $fontSize="18px"
          $fontWeight="400"
          className="mb-2"
          colorHex="#1B131F"
        >
          <strong>Special Offers:</strong> Create exclusive offers and discounts
          for local customers. Promote these offers on your website and through
          email marketing.
          <br />
          <br />
          <strong>Loyalty Programs:</strong> Develop a loyalty program to reward
          repeat customers with discounts, special offers, or early access to
          new collections.
        </StyledText>

        <StyledText
          color="headingColor"
          $fontSize="25px"
          $fontWeight="700"
          className="mb-4 mt-4"
          colorHex="#1B131F"
        >
          6. Educational Content and Workshops
        </StyledText>

        <StyledText
          color="bodyMedium"
          $fontSize="18px"
          $fontWeight="400"
          className="mb-2"
          colorHex="#1B131F"
        >
          <strong>Blog and Guides:</strong> Create a blog or resource section on
          your website with flower care tips, arrangement ideas, and guides for
          different occasions.
          <br />
          <br />
          <strong>Workshops and Classes:</strong> Offer floral arrangement
          workshops and classes to engage with the community and build a loyal
          customer base.
        </StyledText>

        <StyledText
          color="headingColor"
          $fontSize="25px"
          $fontWeight="700"
          className="mb-4 mt-4"
          colorHex="#1B131F"
        >
          7. Local Flair
        </StyledText>

        <StyledText
          color="bodyMedium"
          $fontSize="18px"
          $fontWeight="400"
          className="mb-2"
          colorHex="#1B131F"
        >
          <strong>Local Themes:</strong> Incorporate local themes, symbols, and
          traditions into your floral designs to create a unique connection with
          your community.
          <br />
          <br />
          <strong>Storytelling:</strong> Share the story of your business, your
          team, and your journey. This personal touch can resonate more deeply
          with customers than the impersonal nature of larger companies.
          <br />
          <br />
          By focusing on these strategies, you can create a distinctive brand
          identity and provide a superior customer experience that sets your
          flower shop apart from large order-gathering sites like 1-800-Flowers.
          <br />
          <br />
          Embrace your local roots, showcase your unique offerings, and connect
          with your community to make your flower shop website a go-to
          destination for flower lovers! 🌸
        </StyledText>
      </>
    ),
  },
  {
    author: 'BoostFloral',
    title: 'How to Evaluate the Performance of your Floral Website',
    date: 'Apr 12th, 2024',
    description: 'How to Evaluate the Performance of your Floral Website',
    imageUrl: Blog3Image1,
    tags: ['website tips'],
    content: (
      <>
        <StyledText
          color="bodyMedium"
          $fontSize="18px"
          $fontWeight="400"
          className="mb-4"
          colorHex="#1B131F"
        >
          It's essential to regularly analyze your website's performance to
          ensure that you’re not missing out on potential orders. By monitoring
          key metrics, you can identify potential issues and take the
          appropriate actions to optimize your Floral site for better traffic
          and conversions.
        </StyledText>
        <StyledText
          color="bodyMedium"
          $fontSize="25px"
          $fontWeight="700"
          className="mb-4"
          colorHex="#1B131F"
        >
          Important Floral Website metrics to monitor:
        </StyledText>
        <StyledText
          color="bodyMedium"
          $fontSize="18px"
          $fontWeight="400"
          className="mb-4"
          colorHex="#1B131F"
        >
          <strong>1. High Bounce Rate:</strong> A high bounce rate, which
          measures the percentage of visitors who leave your site after viewing
          only one page, suggests that users are not quickly finding what
          they're looking for or are encountering usability issues that
          discourage further exploration.
          <br />
          <br /> <strong>2. Lack of Engagement Metrics:</strong> Limited
          engagement metrics, such as low time on page, few social shares, or
          minimal interaction with interactive elements (e.g., product
          recommendations, videos), may indicate that your website is not
          effectively engaging visitors or guiding them through the purchasing
          journey.
          <br />
          <br /> <strong>3. Low Conversion Rate:</strong> If your conversion
          rate—the percentage of visitors who complete a desired action, such as
          making a purchase or signing up for a newsletter—is lower than
          industry benchmarks or your own expectations, it may indicate barriers
          to purchase or insufficient persuasive elements on your website.
          <br />
          <br /> <strong>4. Abandoned Carts:</strong> An increasing number of
          abandoned shopping carts suggests that users are interested in your
          products but are not completing the checkout process. This could be
          due to factors such as unexpected costs, complicated checkout
          procedures, or concerns about payment security.
          <br />
          <br /> <strong>5. Poor Search Engine Rankings:</strong> If your
          website is not ranking well for relevant keywords in search engine
          results pages (SERPs), it may struggle to attract organic traffic.
          Conduct regular SEO audits to identify opportunities for optimization
          and improve your site's visibility in search results.
          <br />
          <br />
          <strong>6. Declining Revenue:</strong> A decline in overall revenue or
          average order value can be a clear indicator that your Floral Website
          is not performing as well as it should. It's essential to monitor
          revenue trends over time and identify any significant deviations from
          your expected sales patterns. <br />
          <br />
          If this type of analysis seems overwhelming, find a Partner and Tools
          that can guide you and take on this important responsibility. <br />
          <br />
          This may involve conducting usability testing, improving site speed
          and mobile responsiveness, refining your SEO strategy, enhancing
          product descriptions and calls-to-action, and addressing any concerns
          raised by customers. Regular monitoring and optimization are key to
          maximizing the success of your Floral Website.
        </StyledText>
      </>
    ),
  },
  {
    author: 'BoostFloral',
    title:
      'Floral Customer Purchase Preferences: In-Store vs. Online for Florists',
    date: 'Apr 2nd, 2024',
    description:
      'Floral Customer Purchase Preferences: In-Store vs. Online for Florists',
    imageUrl: TempImage1,
    tags: ['Flower Shop'],
    content: (
      <>
        <StyledText
          color="bodyMedium"
          $fontSize="18px"
          $fontWeight="400"
          className="mb-4"
          colorHex="#1B131F"
        >
          The floral industry, like many others, has seen a significant shift in
          customer purchasing behavior over the past decade. Understanding these
          preferences between in-store and online purchasing is crucial for
          florists who want to grow their business. In this blog, we'll explore
          current trends, predict how these trends will impact the growth of
          flower shops, and offer practical advice on leveraging this
          information to increase revenue.
        </StyledText>
        <StyledText
          color="headingColor"
          $fontSize="25px"
          $fontWeight="700"
          className="mb-4"
          colorHex="#1B131F"
        >
          Customer Purchase Preferences
        </StyledText>
        <StyledText
          color="bodyMedium"
          $fontSize="18px"
          $fontWeight="400"
          className="mb-2"
          colorHex="#1B131F"
        >
          <strong>In-Store Purchases:</strong> In-store purchases still hold a
          special place in the hearts of many customers. The ability to see,
          touch, and smell flowers in person creates an immersive experience
          that can't be replicated online. Customers enjoy the personal
          interaction with knowledgeable staff, the ability to customize
          arrangements on the spot, and the immediate gratification of walking
          out with a beautiful bouquet.
          <br />
          <br />
          <strong>Online Purchases:</strong> Online purchasing has grown
          tremendously due to its convenience and the ability to browse a wide
          variety of options from the comfort of home. This trend has been
          accelerated by the COVID-19 pandemic, which pushed many consumers to
          shop online. Features like same-day delivery, subscription services,
          and the ease of sending flowers to distant loved ones have made online
          shopping very appealing.
        </StyledText>
        <StyledText
          color="headingColor"
          $fontSize="25px"
          $fontWeight="700"
          className="mb-4 mt-4"
          colorHex="#1B131F"
        >
          Impact on the Growth of Flower Shops
        </StyledText>
        <StyledText
          color="bodyMedium"
          $fontSize="18px"
          $fontWeight="400"
          className="mb-2"
          colorHex="#1B131F"
        >
          The rise of online shopping offers both opportunities and challenges
          for traditional flower shops. Here’s how these trends might impact
          your business:
        </StyledText>
        <StyledText
          color="headingColor"
          $fontSize="20px"
          $fontWeight="700"
          className="mb-4 mt-4"
          colorHex="#1B131F"
        >
          Opportunities:
        </StyledText>
        <StyledText
          color="bodyMedium"
          $fontSize="18px"
          $fontWeight="400"
          className="mb-2"
          colorHex="#1B131F"
        >
          <ol>
            <li>
              <strong>Expanded Reach:</strong> An online presence allows you to
              reach a broader audience, including customers who might not visit
              your physical location.
            </li>
            <br />
            <li>
              <strong>Increased Sales:</strong> By offering online ordering, you
              can capture sales from customers who prefer the convenience of
              shopping from home.
            </li>
            <br />
            <li>
              <strong>Customer Data:</strong> Online transactions provide
              valuable data about customer preferences and buying patterns,
              which can be used to tailor marketing efforts.
            </li>
          </ol>
        </StyledText>
        <StyledText
          color="headingColor"
          $fontSize="20px"
          $fontWeight="700"
          className="mb-4 mt-4"
          colorHex="#1B131F"
        >
          Challenges:
        </StyledText>
        <StyledText
          color="bodyMedium"
          $fontSize="18px"
          $fontWeight="400"
          className="mb-2"
          colorHex="#1B131F"
        >
          <ol>
            <li>
              <strong>Competition:</strong> The online market is highly
              competitive, with large players like 1-800-Flowers dominating the
              space.
            </li>
            <br />
            <li>
              <strong>Delivery Logistics:</strong> Ensuring timely and fresh
              delivery can be challenging and requires a reliable system
            </li>
            <br />
            <li>
              <strong>Maintaining Personal Touch:</strong> Providing the same
              level of personalized service online as in-store can be difficult
              but is essential for customer satisfaction
            </li>
          </ol>
        </StyledText>
        <StyledText
          color="headingColor"
          $fontSize="25px"
          $fontWeight="700"
          className="mb-4 mt-4"
          colorHex="#1B131F"
        >
          Recommendations for Growing Revenue
        </StyledText>
        <StyledText
          color="bodyMedium"
          $fontSize="18px"
          $fontWeight="400"
          className="mb-2"
          colorHex="#1B131F"
        >
          To leverage customer purchase preferences and grow your revenue,
          consider these strategies:
          <br />
          <br />
          <ol>
            <li>
              <strong>Develop a Strong Online Presence:</strong> Invest in a
              user-friendly, mobile-optimized website that showcases your
              products beautifully. Ensure the online shopping experience is
              seamless, with clear images, detailed descriptions, and easy
              navigation. Offer features like live chat to provide real-time
              customer support.
            </li>
            <br />
            <li>
              <strong>Offer Unique In-Store Experiences:</strong> Enhance the
              in-store experience to differentiate it from online shopping. Host
              floral arrangement workshops, offer loyalty programs, and create a
              welcoming atmosphere that encourages customers to visit regularly.
            </li>
            <br />
            <li>
              <strong>Combine Online and Offline Strategies:</strong> Use a
              hybrid approach to maximize reach and engagement. For example,
              promote online-only specials to drive traffic to your website,
              while also hosting in-store events to attract local customers.
            </li>
            <br />
            <li>
              <strong>Focus on Delivery Excellence:</strong> Develop a reliable
              delivery system to ensure flowers arrive fresh and on time.
              Partner with reputable delivery services and consider offering
              same-day delivery to cater to last-minute shoppers.
            </li>
            <br />
            <li>
              <strong>Utilize Customer Data:</strong> Leverage data from online
              sales to understand customer preferences and tailor your marketing
              strategies. Use email marketing to send personalized offers and
              updates, and implement retargeting ads to bring back potential
              customers who browsed but didn’t purchase.
            </li>
            <br />
            <li>
              <strong> Emphasize Personalization:</strong> The online market is
              highly competitive, with large players like 1-800-Flowers
              dominating the space.
            </li>
            <br />
            <li>
              <strong>Promote Local Advantage:</strong> Highlight your local
              expertise and community ties. Emphasize the benefits of shopping
              local, such as supporting small businesses and receiving
              personalized service.
            </li>
          </ol>
        </StyledText>
        <StyledText
          color="headingColor"
          $fontSize="25px"
          $fontWeight="700"
          className="mb-4 mt-4"
          colorHex="#1B131F"
        >
          Conclusion
        </StyledText>
        <StyledText
          color="bodyMedium"
          $fontSize="18px"
          $fontWeight="400"
          className="mb-2"
          colorHex="#1B131F"
        >
          Understanding and adapting to customer purchase preferences between
          in-store and online shopping is vital for the growth of your flower
          shop. By developing a strong online presence, enhancing in-store
          experiences, and using data to drive personalized marketing, you can
          create a balanced strategy that caters to both types of customers.
          Embrace these changes, and your business will be well-positioned to
          thrive in the evolving floral market.
          <br />
          <br />
          Invest in these strategies today to grow your revenue and build a
          loyal customer base that appreciates the unique offerings of your
          flower shop. 🌸
        </StyledText>
      </>
    ),
  },
  {
    author: 'BoostFloral',
    title: 'Floral Market Growth Next Year',
    date: 'Mar 31st, 2024',
    description: 'Floral Market Growth Next Year',
    imageUrl: TempImage2,
    tags: ['Flower Shop'],
    content: (
      <>
        <StyledText
          color="bodyMedium"
          $fontSize="18px"
          $fontWeight="400"
          className="mb-4"
          colorHex="#1B131F"
        >
          The floral market is expected to grow next year. Several factors
          contribute to this positive outlook, including increasing consumer
          interest in home decor and gifting, the rising popularity of online
          flower delivery services, and the growing trend of incorporating
          flowers into various events and celebrations.
        </StyledText>
        <StyledText
          color="headingColor"
          $fontSize="25px"
          $fontWeight="700"
          className="mb-4"
          colorHex="#1B131F"
        >
          Growth Opportunities in the Floral Market
        </StyledText>

        <StyledText
          color="bodyMedium"
          $fontSize="18px"
          $fontWeight="400"
          className="mb-2"
          colorHex="#1B131F"
        >
          <ol>
            <li>
              <strong>Online Sales:</strong> The shift towards e-commerce has
              opened significant growth opportunities for the floral market.
              Online flower delivery services are expected to continue growing
              as consumers prioritize convenience and accessibility. Investing
              in a user-friendly, mobile-optimized website and robust delivery
              logistics can help florists tap into this expanding market.
            </li>
            <br />
            <li>
              <strong>Subscription Services:</strong> Subscription-based floral
              services are becoming increasingly popular. Offering regular
              deliveries of fresh flowers to customers' homes or offices can
              create a steady revenue stream and build customer loyalty.
              Subscription services can be tailored for various preferences,
              such as weekly, bi-weekly, or monthly deliveries.
            </li>
            <br />
            <li>
              <strong>Corporate Partnerships:</strong> Partnering with
              businesses to provide corporate floral services can be a lucrative
              opportunity. This includes supplying flowers for office spaces,
              events, and employee recognition programs. Corporate clients often
              require regular and large-scale orders, providing a stable source
              of income.
            </li>
            <br />
            <li>
              <strong>Eco-Friendly and Sustainable Practices:</strong> As
              consumers become more environmentally conscious, there is a
              growing demand for eco-friendly and sustainable floral practices.
              Florists can capitalize on this trend by offering locally sourced
              flowers, sustainable packaging, and organic growing methods.
              Highlighting these practices can attract environmentally conscious
              customers.
            </li>
            <br />
            <li>
              <strong>Events and Weddings:</strong> The events and weddings
              market remains a significant growth area for florists. Despite the
              challenges posed by the COVID-19 pandemic, there is a resurgence
              in event planning, with many people seeking to celebrate postponed
              weddings and events. Providing specialized services for weddings,
              corporate events, and parties can drive substantial business
              growth.
            </li>
            <br />
            <li>
              <strong>Customization and Personalization:</strong> Offering
              customized and personalized floral arrangements can set a flower
              shop apart from competitors. Customers increasingly seek unique,
              tailor-made bouquets for special occasions. Providing options for
              customization can enhance the customer experience and increase
              sales.
            </li>
            <br />
            <li>
              <strong>Health and Wellness:</strong> The health and wellness
              trend presents an opportunity for florists to market flowers as
              part of a holistic approach to well-being. Flowers are known to
              improve mood, reduce stress, and enhance overall mental health.
              Florists can create marketing campaigns that emphasize the
              therapeutic benefits of having fresh flowers at home or in the
              workspace.
            </li>
            <br />
            <li>
              <strong>Seasonal and Holiday Promotions:</strong> Leveraging
              seasonal and holiday promotions can drive significant sales. Key
              occasions like Valentine's Day, Mother's Day, Christmas, and local
              festivals are prime opportunities for targeted marketing
              campaigns. Offering special deals, themed arrangements, and
              early-bird discounts can boost sales during these periods
            </li>
          </ol>
        </StyledText>

        <StyledText
          color="headingColor"
          $fontSize="25px"
          $fontWeight="700"
          className="mb-4"
          colorHex="#1B131F"
        >
          Recommendations for Florists to Grow Revenue
        </StyledText>

        <StyledText
          color="bodyMedium"
          $fontSize="18px"
          $fontWeight="400"
          className="mb-2"
          colorHex="#1B131F"
        >
          <ol>
            <li>
              <strong>Enhance Online Presence:</strong> Develop a strong online
              presence with an easy-to-navigate website and active social media
              profiles. Ensure your website is optimized for mobile devices and
              includes an efficient online ordering system.
            </li>
            <br />
            <li>
              <strong>Offer Flexible Delivery Options:</strong> Provide various
              delivery options, including same-day and next-day delivery, to
              cater to different customer needs. Partner with reliable delivery
              services to ensure timely and fresh deliveries.
            </li>
            <br />
            <li>
              <strong>Invest in Marketing:</strong> Utilize digital marketing
              strategies, such as SEO, social media advertising, and email
              marketing, to reach a broader audience. Highlight customer
              testimonials and reviews to build trust and credibility.
            </li>
            <br />
            <li>
              <strong>Develop Loyalty Programs:</strong> Create loyalty programs
              to reward repeat customers with discounts, special offers, or
              early access to new products. This can help retain customers and
              encourage repeat business.
            </li>
            <br />
            <li>
              <strong>Focus on Quality and Freshness:</strong> Ensure that your
              flowers are of the highest quality and freshness. Sourcing from
              reliable suppliers and maintaining proper storage conditions can
              help achieve this.
            </li>
            <br />
            <li>
              <strong>Educate Customers:</strong> Provide educational content on
              your website or social media about flower care, the benefits of
              fresh flowers, and DIY floral arrangement tips. This can engage
              customers and encourage them to make more frequent purchases.
            </li>
            <br />
            <li>
              <strong>Diversify Product Offerings:</strong> Expand your product
              range to include complementary items such as vases, plant care
              products, and gift baskets. This can increase the average order
              value and attract a wider customer base.
            </li>
          </ol>
        </StyledText>

        <StyledText
          color="bodyMedium"
          $fontSize="18px"
          $fontWeight="400"
          className="mb-2"
          colorHex="#1B131F"
        >
          By leveraging these growth opportunities and implementing strategic
          initiatives, florists can position themselves for success in the
          expanding floral market next year. Embrace the evolving trends, focus
          on customer satisfaction, and continuously innovate to stay ahead of
          the competition. 🌸
        </StyledText>
      </>
    ),
  },
  {
    author: 'BoostFloral',
    title:
      'Why Your Flower Shop Website Might Not Be Getting as Many Orders (And How to Fix It)',
    date: 'Mar 15th, 2024',
    description:
      'Why Your Flower Shop Website Might Not Be Getting as Many Orders (And How to Fix It)',
    imageUrl: TempImage3,
    tags: ['Floral Business'],
    content: (
      <>
        <StyledText
          color="bodyMedium"
          $fontSize="18px"
          $fontWeight="400"
          className="mb-4"
          colorHex="#1B131F"
        >
          Have you ever wondered why your flower shop doesn’t receive as many
          web orders as other flower shops in your area? Or worse, why you're
          losing customers to non-local order-gathering websites? There are
          several reasons this could be happening. Here are some common factors
          to consider and strategies to address them:
        </StyledText>

        <StyledText
          color="headingColor"
          $fontSize="25px"
          $fontWeight="700"
          className="mb-4"
          colorHex="#1B131F"
        >
          1. Website Usability and Design
        </StyledText>

        <StyledText
          color="bodyMedium"
          $fontSize="18px"
          $fontWeight="400"
          className="mb-2"
          colorHex="#1B131F"
        >
          <strong>User Experience (UX):</strong> Make sure your website is
          user-friendly, easy to navigate, and visually appealing. A clean,
          modern design with intuitive navigation can significantly improve how
          customers interact with your site.
          <br />
          <br />
          <strong>Mobile Optimization:</strong> Ensure your website is fully
          optimized for mobile devices, as many customers browse and order from
          their smartphones.
          <br />
          <br />
          <strong>Fast Loading Times:</strong>low loading times can drive
          potential customers away. Use tools like Google PageSpeed Insights to
          check and improve your website’s performance.
        </StyledText>

        <StyledText
          color="headingColor"
          $fontSize="25px"
          $fontWeight="700"
          className="mb-4 mt-4"
          colorHex="#1B131F"
        >
          2. Product Offering and Presentation
        </StyledText>

        <StyledText
          color="bodyMedium"
          $fontSize="18px"
          $fontWeight="400"
          className="mb-2"
          colorHex="#1B131F"
        >
          <strong>High-Quality Images:</strong> Use high-resolution,
          professional images of your flower arrangements. Clear, attractive
          photos can make a big difference in enticing customers to buy.
          <br />
          <br />
          <strong>Detailed Descriptions:</strong> Provide detailed, engaging
          descriptions of each product, highlighting key features and benefits.
          <br />
          <br />
          <strong>Product Variety:</strong> Ensure you offer a wide variety of
          flowers and arrangements to cater to different tastes and occasions.
        </StyledText>

        <StyledText
          color="headingColor"
          $fontSize="25px"
          $fontWeight="700"
          className="mb-4 mt-4"
          colorHex="#1B131F"
        >
          3. Competitive Pricing and Offers
        </StyledText>

        <StyledText
          color="bodyMedium"
          $fontSize="18px"
          $fontWeight="400"
          className="mb-2"
          colorHex="#1B131F"
        >
          <strong>Price Comparison:</strong> Compare your prices with
          competitors to ensure your pricing is competitive while still
          maintaining a healthy profit margin.
          <br />
          <br />
          <strong>Special Offers:</strong> Promote special offers, discounts, or
          bundle deals to attract more customers. Highlight these offers
          prominently on your homepage and product pages.
        </StyledText>

        <StyledText
          color="headingColor"
          $fontSize="25px"
          $fontWeight="700"
          className="mb-4 mt-4"
          colorHex="#1B131F"
        >
          4. Marketing and Advertising
        </StyledText>

        <StyledText
          color="bodyMedium"
          $fontSize="18px"
          $fontWeight="400"
          className="mb-2"
          colorHex="#1B131F"
        >
          <strong>SEO Optimization:</strong> Optimize your website for search
          engines to increase organic traffic. Use relevant keywords in your
          content, meta descriptions, and alt tags.
          <br />
          <br />
          <strong>Google Ads:</strong> Invest in Google Ads to drive targeted
          traffic to your site. Effective keyword targeting and ad copy are key
          to success.
          <br />
          <br />
          <strong>Social Media Marketing:</strong> Leverage social media
          platforms like Facebook, Instagram, and Pinterest to showcase your
          products and drive traffic to your site.
        </StyledText>

        <StyledText
          color="headingColor"
          $fontSize="25px"
          $fontWeight="700"
          className="mb-4 mt-4"
          colorHex="#1B131F"
        >
          5. Customer Trust and Reviews
        </StyledText>

        <StyledText
          color="bodyMedium"
          $fontSize="18px"
          $fontWeight="400"
          className="mb-2"
          colorHex="#1B131F"
        >
          <strong>Customer Reviews:</strong> Display customer reviews and
          testimonials on your website. Positive reviews build trust and can
          influence purchasing decisions.
          <br />
          <br />
          <strong>Trust Signals:</strong> Include trust signals such as secure
          payment icons, money-back guarantees, and clear return policies.
        </StyledText>

        <StyledText
          color="headingColor"
          $fontSize="25px"
          $fontWeight="700"
          className="mb-4 mt-4"
          colorHex="#1B131F"
        >
          6. Local SEO and Community Engagement
        </StyledText>

        <StyledText
          color="bodyMedium"
          $fontSize="18px"
          $fontWeight="400"
          className="mb-2"
          colorHex="#1B131F"
        >
          <strong>Google My Business:</strong>Ensure your Google My Business
          listing is complete and optimized with accurate information,
          high-quality photos, and positive reviews.
          <br />
          <br />
          <strong>Local Listings:</strong> Get listed in local directories and
          participate in community events to increase local visibility.
          <br />
          <br />
          <strong>Local Partnerships:</strong> Partner with local businesses or
          event planners to offer special deals or collaborate on promotions.
        </StyledText>

        <StyledText
          color="headingColor"
          $fontSize="25px"
          $fontWeight="700"
          className="mb-4 mt-4"
          colorHex="#1B131F"
        >
          7. Analytics and Continuous Improvement
        </StyledText>

        <StyledText
          color="bodyMedium"
          $fontSize="18px"
          $fontWeight="400"
          className="mb-2"
          colorHex="#1B131F"
        >
          <strong>Monitor Analytics:</strong> Use Google Analytics to track user
          behavior, traffic sources, and conversion rates. Identify areas where
          users drop off and optimize those parts of your website.
          <br />
          <br />
          <strong>A/B Testing:</strong> Continuously test different aspects of
          your website (e.g., layout, product pages, CTAs) to see what works
          best in converting visitors into customers.
          <br />
          <br />
          By addressing these areas, you can identify potential issues and
          implement improvements to boost orders on your flower shop website.
          Regularly reviewing performance data and staying updated with industry
          trends will help you stay competitive and attract more customers.
          <br />
          <hr />
          <br />
          Taking these steps can help ensure your flower shop website stands out
          and attracts more customers, even in a competitive market. Remember,
          the goal is to provide a seamless, enjoyable shopping experience that
          keeps customers coming back for more. Happy selling! 🌸
        </StyledText>
      </>
    ),
  },
  {
    author: 'BoostFloral',
    title: 'Most Popular Floral Arrangement of Last Year',
    date: 'Feb 13th, 2024',
    description: 'Most Popular Floral Arrangement of Last Year',
    imageUrl: TempImage4,
    tags: ['Flower Shop'],
    content: (
      <>
        <StyledText
          color="bodyMedium"
          $fontSize="18px"
          $fontWeight="400"
          className="mb-4"
          colorHex="#1B131F"
        >
          Determining the most popular floral arrangement purchased last year
          can vary depending on the source, but generally, classic and versatile
          arrangements tend to be favorites. Based on industry trends and
          reports from major florists, here are some insights:
        </StyledText>

        <StyledText
          color="bodyMedium"
          $fontSize="18px"
          $fontWeight="400"
          className="mb-2"
          colorHex="#1B131F"
        >
          <strong>Roses:</strong> Roses, especially red roses, continue to be
          the top choice for many occasions, particularly for romantic gestures
          such as Valentine's Day and anniversaries. Mixed rose bouquets in
          various colors also gained popularity, offering a vibrant and diverse
          look that appeals to a wide range of customers.
          <br />
          <br />
          <strong>Mixed Bouquetsn:</strong> Mixed bouquets that combine a
          variety of flowers such as roses, lilies, daisies, and greenery were
          extremely popular. These arrangements offer a rich diversity of colors
          and textures, making them suitable for a wide array of occasions from
          birthdays to thank-you gifts
          <br />
          <br />
          <strong>Succulent Arrangements:</strong> Succulents have become
          increasingly trendy due to their low maintenance and unique
          appearance. Arrangements featuring a mix of succulents and flowers
          were a hit, providing a modern and long-lasting alternative to
          traditional bouquets.
          <br />
          <br />
          <strong>Seasonal Arrangements:</strong> Seasonal arrangements that
          reflect the colors and flowers of the season were in high demand. For
          example, spring bouquets often featured tulips and daffodils, while
          autumn arrangements included sunflowers and chrysanthemums.
          <br />
          <br />
          <strong>Orchids:</strong> Elegant orchid arrangements, both as potted
          plants and as part of mixed floral arrangements, saw a surge in
          popularity. Orchids are prized for their exotic look and long-lasting
          blooms.
        </StyledText>

        <StyledText
          color="headingColor"
          $fontSize="25px"
          $fontWeight="700"
          className="mb-4 mt-4"
          colorHex="#1B131F"
        >
          How to Use This Information to Grow Your Revenue
        </StyledText>

        <StyledText
          color="bodyMedium"
          $fontSize="18px"
          $fontWeight="400"
          className="mb-2"
          colorHex="#1B131F"
        >
          <ol>
            <li>
              <strong>Stock Popular Flowers:</strong> Ensure that your shop
              always has a good supply of popular flowers like roses, lilies,
              and seasonal blooms. This will help you meet customer demand,
              especially during peak seasons.
            </li>
            <br />
            <li>
              <strong>Promote Bestsellers:</strong> Highlight your most popular
              arrangements on your website and social media. Create special
              promotions or discounts for these top-selling items to attract
              more customers.
            </li>
            <br />
            <li>
              <strong>Offer Customization:</strong> Provide options for
              customers to customize their arrangements by adding or
              substituting flowers. This personal touch can increase customer
              satisfaction and loyalty.
            </li>
            <br />
            <li>
              <strong>Leverage Seasonal Trends:</strong> Stay ahead of seasonal
              trends by offering arrangements that reflect current seasons or
              upcoming holidays. Promote these seasonal offerings through email
              marketing and social media campaigns.
            </li>
            <br />
            <li>
              <strong>Create Unique Arrangements:</strong> Differentiate your
              shop by creating unique and exclusive arrangements that can’t be
              found at larger chain stores or online giants. Use your local
              knowledge and creativity to design one-of-a-kind bouquets.
            </li>
            <br />
            <li>
              <strong>Customer Feedback:</strong> Regularly seek feedback from
              your customers to understand their preferences and adjust your
              inventory and offerings accordingly. Conduct surveys or ask for
              reviews to gain insights.
            </li>
            <br />
            <li>
              <strong>Educational Content:</strong> Share care tips and floral
              arrangement ideas through blogs or social media. Educate your
              customers on how to care for their flowers to ensure they last
              longer, which can enhance their overall experience and encourage
              repeat purchases.
            </li>
            <br />
          </ol>
        </StyledText>

        <StyledText
          color="bodyMedium"
          $fontSize="18px"
          $fontWeight="400"
          className="mb-2"
          colorHex="#1B131F"
        >
          By focusing on popular floral arrangements and adapting your offerings
          to meet customer preferences, you can boost sales and grow your
          revenue effectively. Stay attuned to trends, offer exceptional
          service, and create beautiful, high-quality arrangements to keep your
          customers coming back. 🌸
        </StyledText>
      </>
    ),
  },
  {
    author: 'BoostFloral',
    title: 'Using Google Ads to Market Your Flower Shop Website',
    date: 'Jan 28th, 2024',
    description: 'Using Google Ads to Market Your Flower Shop Website',
    imageUrl: TempImage5,
    tags: ['website tips', 'floral website design'],
    content: (
      <>
        <StyledText
          color="bodyMedium"
          $fontSize="18px"
          $fontWeight="400"
          className="mb-4"
          colorHex="#1B131F"
        >
          Are you looking to boost orders on your flower shop website? Using
          Google Ads effectively can make a huge difference. Here’s a friendly,
          easy-to-follow guide to help you get the most out of your Google Ads
          campaigns.
        </StyledText>

        <StyledText
          color="headingColor"
          $fontSize="25px"
          $fontWeight="700"
          className="mb-4"
          colorHex="#1B131F"
        >
          1. Keyword Research
        </StyledText>

        <StyledText
          color="bodyMedium"
          $fontSize="18px"
          $fontWeight="400"
          className="mb-2"
          colorHex="#1B131F"
        >
          <strong>Identify Keywords:</strong> Start by using Google Keyword
          Planner to find keywords related to your business. Think about what
          your customers might search for, like “flower delivery,” “roses,”
          “tulips,” “birthday flowers,” or “flower delivery in [your city].”
          <br />
          <br />
          <strong>Long-Tail Keywords:</strong> These are more specific phrases
          that have less competition. For example, “same-day flower delivery in
          [your city].” These keywords can be very effective.
        </StyledText>

        <StyledText
          color="headingColor"
          $fontSize="25px"
          $fontWeight="700"
          className="mb-4 mt-4"
          colorHex="#1B131F"
        >
          2. Ad Copy
        </StyledText>

        <StyledText
          color="bodyMedium"
          $fontSize="18px"
          $fontWeight="400"
          className="mb-2"
          colorHex="#1B131F"
        >
          <strong>Compelling Headlines:</strong> Create headlines that grab
          attention and include your main keywords. Try something like
          “Beautiful Fresh Flowers Delivered Today.”
          <br />
          <br />
          <strong>Clear Value Proposition:</strong> Highlight what makes your
          shop special. Do you offer free delivery, same-day service, or a
          satisfaction guarantee? Let your customers know!
          <br />
          <br />
          <strong>Call-to-Action (CTA):</strong> Encourage people to act with
          strong CTAs like “Order Now,” “Shop Today,” or “Get Fresh Flowers
          Delivered.”
        </StyledText>

        <StyledText
          color="headingColor"
          $fontSize="25px"
          $fontWeight="700"
          className="mb-4 mt-4"
          colorHex="#1B131F"
        >
          3. Ad Extensions
        </StyledText>

        <StyledText
          color="bodyMedium"
          $fontSize="18px"
          $fontWeight="400"
          className="mb-2"
          colorHex="#1B131F"
        >
          <strong>Sitelink Extensions:</strong> Use these to direct people to
          specific parts of your website, like special offers, best sellers, or
          specific flower categories
          <br />
          <br />
          <strong>Call Extensions:</strong> Let customers call you directly from
          the ad—perfect for urgent orders!
          <br />
          <br />
          <strong>Location Extensions:</strong> Show your shop’s address to
          attract local customers.
        </StyledText>

        <StyledText
          color="headingColor"
          $fontSize="25px"
          $fontWeight="700"
          className="mb-4 mt-4"
          colorHex="#1B131F"
        >
          4. Targeting
        </StyledText>

        <StyledText
          color="bodyMedium"
          $fontSize="18px"
          $fontWeight="400"
          className="mb-2"
          colorHex="#1B131F"
        >
          <strong>Geographic Targeting:</strong> Focus your ads on your delivery
          area to make sure they’re shown to people who can actually use your
          service.
          <br />
          <br />
          <strong>Demographic Targeting:</strong> Tailor your ads based on age,
          gender, or income if it makes sense for your customer base.
        </StyledText>

        <StyledText
          color="headingColor"
          $fontSize="25px"
          $fontWeight="700"
          className="mb-4 mt-4"
          colorHex="#1B131F"
        >
          5. Budget and Bidding
        </StyledText>

        <StyledText
          color="bodyMedium"
          $fontSize="18px"
          $fontWeight="400"
          className="mb-2"
          colorHex="#1B131F"
        >
          <strong>Set a Realistic Budget:</strong> Decide on a daily budget that
          fits your marketing goals and financial situation.
          <br />
          <br />
          <strong>Bid Strategically:</strong> Use automated bidding strategies
          like Target CPA (Cost Per Acquisition) to optimize your bids for the
          best results.
        </StyledText>

        <StyledText
          color="headingColor"
          $fontSize="25px"
          $fontWeight="700"
          className="mb-4 mt-4"
          colorHex="#1B131F"
        >
          6. Landing Pages
        </StyledText>

        <StyledText
          color="bodyMedium"
          $fontSize="18px"
          $fontWeight="400"
          className="mb-2"
          colorHex="#1B131F"
        >
          <strong>Relevance:</strong> Make sure your landing page matches your
          ad. If you’re advertising rose bouquets, the landing page should
          feature rose bouquets prominently.
          <br />
          <br />
          <strong>Optimization:</strong> Your landing page should load quickly,
          be mobile-friendly, and have a clear path to purchase.
          <br />
          <br />
          <strong>A/B Testing:</strong> Test different designs and content to
          see what works best.
        </StyledText>

        <StyledText
          color="headingColor"
          $fontSize="25px"
          $fontWeight="700"
          className="mb-4 mt-4"
          colorHex="#1B131F"
        >
          7. Remarketing
        </StyledText>

        <StyledText
          color="bodyMedium"
          $fontSize="18px"
          $fontWeight="400"
          className="mb-2"
          colorHex="#1B131F"
        >
          <strong>Retarget Visitors:</strong> Show ads to people who visited
          your site but didn’t buy. Offer special discounts or highlight popular
          items to bring them back.
          <br />
          <br />
          <strong>Dynamic Remarketing:</strong> Show personalized ads featuring
          the specific products they looked at on your site.
        </StyledText>

        <StyledText
          color="headingColor"
          $fontSize="25px"
          $fontWeight="700"
          className="mb-4 mt-4"
          colorHex="#1B131F"
        >
          8. Monitoring and Optimization
        </StyledText>

        <StyledText
          color="bodyMedium"
          $fontSize="18px"
          $fontWeight="400"
          className="mb-2"
          colorHex="#1B131F"
        >
          <strong>Track Performance:</strong> Use Google Analytics and Google
          Ads reports to keep an eye on how your campaigns are doing. Look at
          metrics like click-through rate (CTR), conversion rate, and return on
          ad spend (ROAS).
          <br />
          <br />
          <strong>Optimize Keywords:</strong> Pause keywords that aren’t
          performing well and put more budget toward the ones that are. Adjust
          your keyword match types (broad, phrase, exact) to refine your
          targeting.
          <br />
          <br />
          <strong>Refine Ad Copy</strong> Keep testing and tweaking your ad copy
          to make it as effective as possible.
        </StyledText>

        <StyledText
          color="headingColor"
          $fontSize="25px"
          $fontWeight="700"
          className="mb-4 mt-4"
          colorHex="#1B131F"
        >
          9. Seasonal and Event Promotions
        </StyledText>

        <StyledText
          color="bodyMedium"
          $fontSize="18px"
          $fontWeight="400"
          className="mb-2"
          colorHex="#1B131F"
        >
          <strong>Holiday Campaigns:</strong> Plan ahead for major holidays and
          events like Valentine’s Day, Mother’s Day, and Christmas when flower
          sales are high.
          <br />
          <br />
          <strong>Special Events:</strong> Run ads for local events or festivals
          to increase demand for your flowers.
        </StyledText>

        <StyledText
          color="headingColor"
          $fontSize="25px"
          $fontWeight="700"
          className="mb-4 mt-4"
          colorHex="#1B131F"
        >
          10. Local SEO Integration
        </StyledText>

        <StyledText
          color="bodyMedium"
          $fontSize="18px"
          $fontWeight="400"
          className="mb-2"
          colorHex="#1B131F"
        >
          <strong>Google My Business:</strong> Make sure your profile is up to
          date with accurate information, high-quality images, and customer
          reviews.
          <br />
          <br />
          <strong>Local Listings:</strong> Optimize your website for local
          search terms and ensure your business is listed in local directories.
        </StyledText>

        <StyledText
          color="bodyMedium"
          $fontSize="18px"
          $fontWeight="400"
          className="mb-2"
          colorHex="#1B131F"
        >
          By following these steps, you can create a Google Ads campaign that
          drives more orders to your flower shop website. Regularly review and
          adjust your strategy based on performance data to get the best
          results.
          <br />
          <br />
          Happy advertising! 🌸
        </StyledText>
      </>
    ),
  },
];

const tags = [
  'floral website design',
  'website tips',
  'Floral Business',
  'Flower Shop',
];

const settings = {
  dots: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  initialSlide: 0,
  adaptiveHeight: true,
  variableWidth: true,
};

const BlogListing = () => {
  const [filterTags, setFilterTags] = useState([]);

  const handleFilterTagsChange = (e, tag) => {
    if (e.target.checked) {
      setFilterTags((prev) => [...prev, tag]);
    } else {
      setFilterTags((prev) => prev.filter((t) => t !== tag));
    }
  };

  const filteredBlogs = useMemo(() => {
    return filterTags?.length
      ? data?.filter((item) =>
          item.tags?.some((tag) => filterTags.includes(tag)),
        ) ?? []
      : data;
  }, [filterTags, data]);

  return (
    <Routes>
      <Route
        path="/"
        element={
          <BlogList
            filterTags={filterTags}
            handleFilterTagsChange={handleFilterTagsChange}
            filteredBlogs={filteredBlogs}
            clearAllTags={() => setFilterTags([])}
          />
        }
      />
      <Route path="/:slug" element={<BlogDetail />} />
    </Routes>
  );
};

const BlogList = ({
  filterTags,
  handleFilterTagsChange,
  filteredBlogs,
  clearAllTags,
}) => {

  const navigate = useNavigate();
  return (
    <>
      <Helmet>
        <title>Floral Blogs by BoostFloral</title>
        <meta name="description" content="Discover expert tips and strategies to enhance your floral website. BoostFloral's blog offers valuable insights to help you create a stunning, user-friendly, and successful floral site." />
        <meta property="og:type" content="blog" />
        <meta property="og:site_name" content="BoostFloral" />
        <meta property="og:title" content='Floral Blogs by BoostFloral' />
        <meta property="og:url" content={`${process.env.REACT_APP_APP_URL}/blogs`} />
        <meta property="og:image" content={`${process.env.REACT_APP_APP_URL}${logoIcon}`} />
        <meta property="og:description" content="Discover expert tips and strategies to enhance your floral website. BoostFloral's blog offers valuable insights to help you create a stunning, user-friendly, and successful floral site." />
      </Helmet>
      <SwiperContainer>
        {filteredBlogs?.length === 1 ? (
          <StyledBanner key={filteredBlogs[0].title}>
            <Container>
              <Row className="row-reverse align-items-stretch">
                <Col xs={12} md={7}>
                  <div className="d-flex flex-column align-items-start justify-content-center py-4 h-100">
                    <StyledText
                      color="white"
                      $fontWeight="500"
                      $fontSize="16px"
                    >
                      {filteredBlogs[0].date}
                    </StyledText>
                    <StyledText
                      color="white"
                      $fontWeight="500"
                      $fontSize="36px"
                      as="h2"
                      className="overflow-hidden"
                      style={{
                        lineHeight: '40px',
                        maxHeight: '80px',
                      }}
                    >
                      {filteredBlogs[0].title}
                    </StyledText>
                    <StyledText
                      color="white"
                      $fontWeight="400"
                      $fontSize="18px"
                      className="mb-4"
                    >
                      {filteredBlogs[0].description}
                    </StyledText>
                    <Link
                      to={`/blogs/${filteredBlogs[0].title
                        .toLowerCase()
                        .replace(/\s+/g, '-')}`}
                    >
                      <StyledButton
                        type="button"
                        $fontSize="16px"
                        $fontWeight="500"
                        $paddingX="0.5rem"
                        $paddingY="0.2rem"
                      >
                        Read More
                      </StyledButton>
                    </Link>
                  </div>
                </Col>
                <Col
                  xs={12}
                  md={5}
                  className="d-flex align-items-center justify-content-center"
                >
                  <div style={{ height: '250px', width: '250px' }}>
                    <img
                      style={{ height: '100%', width: '100%' }}
                      src={filteredBlogs[0].imageUrl}
                      alt=""
                    />
                  </div>
                </Col>
              </Row>
            </Container>
          </StyledBanner>
        ) : (
          <Slider
            infinite={true}
            {...settings}
            className="templateSlider mobile-hide-slider"
          >
            {data?.slice(0, 3)?.map((item) => (
              <StyledBanner key={item.title}>
                <Container className="">
                  <Row className="p-4 d-flex flex-row align-items-center justify-content-center">
                    <Col xs={12} md={7}>
                      <div className="d-flex flex-column align-items-start justify-content-around">
                        <StyledText
                          color="white"
                          $fontWeight="500"
                          $fontSize="16px"
                        >
                          {item.date}
                        </StyledText>
                        <StyledText
                          color="white"
                          $fontWeight="500"
                          $fontSize="36px"
                          as="h2"
                          className="overflow-hidden"
                          style={{
                            lineHeight: '40px',
                            minHeight: '80px',
                            maxHeight: '80px',
                          }}
                        >
                          {item.title}
                        </StyledText>
                        <StyledText
                          color="white"
                          $fontWeight="400"
                          $fontSize="18px"
                          className="overflow-hidden"
                          style={{
                            lineHeight: '24px',
                            minHeight: '72px',
                            maxHeight: '72px',
                          }}
                        >
                          {item.description}
                        </StyledText>
                        <Link
                          to={`/blogs/${item.title
                            .toLowerCase()
                            .replace(/\s+/g, '-')}`}
                        >
                          <StyledButton
                            type="button"
                            $fontSize="18px"
                            $fontWeight="500"
                          >
                            Read More
                          </StyledButton>
                        </Link>
                      </div>
                    </Col>
                    <Col
                      md={5}
                      className="d-flex align-items-center justify-content-center"
                    >
                      <div style={{ height: '300px', width: '100%' }}>
                        <img
                          style={{ objectFit: 'contain' }}
                          src={item.imageUrl}
                          alt=""
                          className="h-100 w-100"
                        />
                      </div>
                    </Col>
                  </Row>
                </Container>
              </StyledBanner>
            ))}
          </Slider>
        )}
      </SwiperContainer>

      <Container className="py-5">
        <Row>
          <Col xs={12} md={3}>
            <StyledText
              color="headingColor"
              $fontWeight="500"
              $fontSize="24px"
              className="mb-4"
            >
              Categories
            </StyledText>
            <div>
              {tags.map((item) => (
                <div key={item} className="mb-2">
                  <StyledCheckbox
                    label={
                      <StyledText
                        color="headingColor"
                        $fontWeight="400"
                        $fontSize="16px"
                        className="text-capitalize m-0"
                      >
                        {item}
                      </StyledText>
                    }
                    value={filterTags.includes(item)}
                    onChange={(e) => handleFilterTagsChange(e, item)}
                  />
                </div>
              ))}
            </div>
            <div className="d-flex justify-content-center justify-content-md-start my-3">
              <StyledButton
                type="button"
                $fontWeight="500"
                $fontSize="16px"
                onClick={clearAllTags}
                className="px-2"
                $paddingX="0.5rem"
                $paddingY="0.2rem"
              >
                Clear All
              </StyledButton>
            </div>
          </Col>
          <Col xs={12} md={9}>
            <Row className="align-items-stretch g-4">
              {filteredBlogs?.map((item) => (
                <Col xs={12} md={6} lg={4}>
                  <StyledCard
                    key={item.title}
                    className="shadow h-100 position-relative"
                    onClick={() =>
                      navigate(
                        `/blogs/${item.title
                          .toLowerCase()
                          .replace(/\s+/g, '-')}`,
                      )
                    }
                  >
                    <div>
                      <img
                        className="p-1"
                        style={{ objectFit: 'contain' }}
                        src={item.imageUrl}
                        alt=""
                      ></img>
                    </div>
                    <div className="d-flex flex-column align-items-start p-4">
                      <div className="d-flex flex-column align-items-start">
                        {item.tags?.map((item) => (
                          <StyledText
                            key={item}
                            color="bodyMedium"
                            $fontWeight="300"
                            $fontSize="14px"
                            className="text-capitalize"
                            colorHex="#C70081"
                            style={{
                              backgroundColor: '#ECD9E5',
                              padding: '5px 15px',
                              borderRadius: 10,
                            }}
                          >
                            {item}
                          </StyledText>
                        ))}
                      </div>
                      <StyledText
                        color="headingColor"
                        $fontWeight="500"
                        $fontSize="24px"
                        as="h2"
                        className="mb-2 overflow-hidden"
                        style={{
                          lineHeight: '28px',
                          maxHeight: '56px',
                        }}
                      >
                        {item.title}
                      </StyledText>
                      <StyledText
                        color="bodyMedium"
                        $fontWeight="400"
                        $fontSize="16px"
                        className="mb-2"
                        colorHex=""
                      >
                        {item.description}
                      </StyledText>
                      <StyledText
                        color="bodyMedium"
                        $fontWeight="300"
                        $fontSize="14px"
                        colorHex="#9426E9"
                      >
                        {item.date}
                      </StyledText>
                    </div>
                  </StyledCard>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  );
};

const BlogDetail = () => {
  const { slug } = useParams();
  const blog = data.find(
    (item) => item.title.toLowerCase().replace(/\s+/g, '-') === slug,
  );

  const navigate = useNavigate();

  if (!blog) {
    return (
      <Container className="">
        <Row className="row-reverse align-items-stretch">
          <Col>
            <div
              className="p-4 w-100 d-flex justify-content-center align-items-center"
              style={{ height: 'calc(50vh - 115px)' }}
            >
              <StyledText
                color="bodyMedium"
                $fontWeight="500"
                $fontSize="44px"
                as="h1"
              >
                No Blog found
              </StyledText>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }

  return (
    <>
      <Helmet>
        <title>{blog.title}</title>
        <meta property="og:type" content="blog" />
        <meta property="og:site_name" content="BoostFloral" />
        <meta name="description" content={blog.description} />
        <meta property="og:title" content={blog.title} />
        <meta property="og:description" content={blog.description} />
        <meta property="og:image" content={`${process.env.REACT_APP_APP_URL}/${blog.imageUrl}`} />
        <meta property="og:url" content={`${process.env.REACT_APP_APP_URL}/blogs/${blog.title}`} />
      </Helmet>
      <Container className="py-4">
        <Row>
          <Col
            className="d-flex flex-column justify-content-center align-items-center"
            xs={12}
            md={5}
          >
            <div
              className="d-flex justify-content-center align-items-center w-100"
              style={{ height: '300px' }}
            >
              <img
                className="w-100"
                style={{ objectFit: 'contain', height: '300px' }}
                src={blog.imageUrl}
                alt=""
              />
            </div>
          </Col>
          <Col
            className="d-flex justify-content-center align-items-center"
            xs={12}
            md={7}
          >
            <div className="d-flex flex-column align-items-start">
              <StyledText
                color="black"
                $fontWeight="500"
                $fontSize="44px"
                as="h1"
                colorHex="#1B131F"
              >
                {blog.title}
              </StyledText>
              <StyledText
                color="black"
                $fontWeight="400"
                $fontSize="18px"
                colorHex="#1B131F"
              >
                {blog.description}
              </StyledText>
              <div className="d-flex gap-1 flex-wrap">
                {blog.tags?.map((item, index) => (
                  <StyledText
                    $fontSize="16px"
                    $fontWeight="300"
                    className="text-capitalize"
                    colorHex="#C70081"
                    style={{
                      backgroundColor: '#ECD9E5',
                      padding: '5px 15px',
                      borderRadius: 10,
                    }}
                  >
                    {`${item}${blog.tags?.length - 1 !== index ? ',' : ''}`}
                  </StyledText>
                ))}
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <StyledText
              color="bodyMedium"
              $fontSize="18px"
              $fontWeight="500"
              className="mt-5 text-capitalize"
            >
              {blog.author} | {blog.date}
            </StyledText>
          </Col>
        </Row>
      </Container>

      <Container>
        <Row className="g-4">
          <Col>
            {/* <div dangerouslySetInnerHTML={{ __html: blog?.content }} /> */}
            {blog.content}
          </Col>
        </Row>
      </Container>

      <Container className="py-5">
        <Row>
          <Col>
            <StyledText
              color="headingColor"
              $fontSize="24px"
              $fontWeight="500"
              className="mb-4 text-capitalize"
            >
              Related Content
            </StyledText>
          </Col>
        </Row>
        <Row className="align-items-stretch g-4">
          {data?.slice(0, 3)?.map((item) => (
            <Col xs={12} md={6} lg={4}>
              <StyledCard
                key={item.title}
                className="shadow h-100 position-relative"
                onClick={() => navigate(`/blogs/${item.title.toLowerCase().replace(/\s+/g, '-')}`)}
              >
                <div>
                  <img
                    className="mt-1"
                    style={{ objectFit: 'contain' }}
                    src={item.imageUrl}
                    alt=""
                  ></img>
                </div>
                <div className="d-flex flex-column align-items-start p-4">
                  <StyledText
                    color="headingColor"
                    $fontWeight="500"
                    $fontSize="24px"
                    as="h2"
                    className="mb-2"
                  >
                    {item.title}
                  </StyledText>
                </div>
              </StyledCard>
            </Col>
          ))}
        </Row>
      </Container>
    </>
  );
};

export default BlogListing;
